<p-toast
  position="top-right"
  [pt]="{
    root: { class: 'border-0' },
    message: { class: '!p-0 !m-0 !border-0 !bg-transparent !shadow-none !rounded-none' },
    messageContent: { class: '!p-0 !m-0 !border-0 !bg-transparent' }
  }"
>
  <ng-template #headless let-message let-closeFn="closeFn">
    <div
      class="flex w-[350px] items-start gap-2.5 rounded-md border p-3 shadow-md backdrop-blur-sm"
      [ngClass]="getContainerClasses(message.severity)"
    >
      <!-- Icon -->
      <div class="flex h-5 shrink-0 items-end">
        <i [class]="getIconClass(message.severity) + ' text-base ' + getColorClasses(message.severity)"></i>
      </div>

      <!-- Text content -->
      <div class="flex min-w-0 flex-1 flex-col gap-1.5">
        <span
          class="text-lg font-black leading-snug"
          [ngClass]="getColorClasses(message.severity)"
        >
          {{ message.summary }}
        </span>
        @if (message.detail || message.data?.linkText) {
          <span class="text-base font-normal leading-normal text-slate-700">
            @if (message.data?.linkText && message.data?.linkPath) {
              @if (message.detail) {
                {{ message.detail }}
              }
              <a
                [routerLink]="message.data.linkPath"
                [queryParams]="message.data.linkQueryParams ?? {}"
                class="text-blue-600 underline font-semibold hover:text-blue-700 hover:opacity-90"
              >{{ message.data.linkText }}</a>
            } @else if (message.data?.escape === false) {
              <span [innerHTML]="message.detail"></span>
            } @else {
              {{ message.detail }}
            }
          </span>
        }
      </div>

      <!-- Close button -->
      <button
        type="button"
        class="flex size-6 shrink-0 cursor-pointer items-center justify-center rounded-xl border-none bg-transparent transition-opacity hover:opacity-70"
        [ngClass]="getColorClasses(message.severity)"
        (click)="closeFn($event)"
      >
        <i class="pi pi-times text-sm"></i>
      </button>
    </div>
  </ng-template>
</p-toast>
